import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { Input } from "../../ui/input";
import { Calendar } from "../../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover";
import { auToIso, isoToAu, isoToLocalDate, localDateToIso, maskAu } from "./auDate";

// Shows/accepts DD/MM/YYYY; value and onChange are always ISO YYYY-MM-DD ("" when empty).
export function AuDateInput({ value, onChange, testid }) {
  const [text, setText] = useState(isoToAu(value));
  const [open, setOpen] = useState(false);
  useEffect(() => { setText(isoToAu(value)); }, [value]);
  const typed = (raw) => {
    const t = maskAu(raw);
    setText(t);
    if (!t) onChange("");
    else { const iso = auToIso(t); if (iso) onChange(iso); }
  };
  const invalid = text.length === 10 && !auToIso(text);
  return (
    <div className="flex gap-1">
      <Input value={text} onChange={(e) => typed(e.target.value)} placeholder="DD/MM/YYYY" inputMode="numeric"
        className={`h-9 ${invalid ? "border-red-400" : ""}`} data-testid={testid} aria-invalid={invalid} />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" className="h-9 px-2 border border-input hover:bg-[#9A7B4F]/5" aria-label="Pick a date" data-testid={`${testid}-calendar-btn`}>
            <CalendarDays className="w-4 h-4 text-[#9A7B4F]" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar mode="single" weekStartsOn={1} selected={isoToLocalDate(value)} defaultMonth={isoToLocalDate(value)}
            onSelect={(d) => { if (d) { onChange(localDateToIso(d)); setOpen(false); } }} initialFocus data-testid={`${testid}-calendar`} />
        </PopoverContent>
      </Popover>
      {invalid && <span className="sr-only" data-testid={`${testid}-invalid`}>Invalid date</span>}
    </div>
  );
}
